import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Menu, X } from "lucide-react";

const LOGO_COLOR = "https://customer-assets.emergentagent.com/job_2f7e215b-21fb-4724-b9fe-01f573af4d89/artifacts/06a0r6yy_Tailwind%20logo-Full-C.png";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    setMobileOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-white/95 backdrop-blur-sm shadow-sm" : "bg-white"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 flex items-center justify-between h-28">
        <a href="/" data-testid="header-logo-link" className="shrink-0">
          <img
            src={LOGO_COLOR}
            alt="Tailwind Corporation"
            className="h-20 w-auto"
            data-testid="header-logo"
          />
        </a>

        {/* Desktop nav */}
        <nav className="hidden md:flex items-center gap-10" data-testid="desktop-nav">
          <button
            onClick={() => scrollTo("framework")}
            className="text-sm font-medium text-[#4A5568] hover:text-[#182649] transition-colors tracking-wide uppercase"
            data-testid="nav-framework"
          >
            Framework
          </button>
          <button
            onClick={() => scrollTo("spaces")}
            className="text-sm font-medium text-[#4A5568] hover:text-[#182649] transition-colors tracking-wide uppercase"
            data-testid="nav-spaces"
          >
            Spaces
          </button>
          <button
            onClick={() => scrollTo("eleven41")}
            className="text-sm font-medium text-[#4A5568] hover:text-[#182649] transition-colors tracking-wide uppercase"
            data-testid="nav-projects"
          >
            Projects
          </button>
          <button
            onClick={() => scrollTo("team")}
            className="text-sm font-medium text-[#4A5568] hover:text-[#182649] transition-colors tracking-wide uppercase"
            data-testid="nav-team"
          >
            Team
          </button>
          <Button
            onClick={() => scrollTo("contact")}
            className="bg-[#182649] text-white hover:bg-[#3C75B6] rounded-full px-6 py-2 text-sm font-medium transition-all duration-300"
            data-testid="nav-cta-button"
          >
            Get Details
          </Button>
        </nav>

        {/* Mobile menu toggle */}
        <button
          className="md:hidden p-2 text-[#182649]"
          onClick={() => setMobileOpen(!mobileOpen)}
          data-testid="mobile-menu-toggle"
        >
          {mobileOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile nav */}
      {mobileOpen && (
        <div className="md:hidden bg-white border-t border-[#E2E8F0] px-6 pb-6 pt-4 space-y-4" data-testid="mobile-nav">
          <button onClick={() => scrollTo("framework")} className="block text-sm font-medium text-[#4A5568] uppercase tracking-wide" data-testid="mobile-nav-framework">Framework</button>
          <button onClick={() => scrollTo("spaces")} className="block text-sm font-medium text-[#4A5568] uppercase tracking-wide" data-testid="mobile-nav-spaces">Spaces</button>
          <button onClick={() => scrollTo("eleven41")} className="block text-sm font-medium text-[#4A5568] uppercase tracking-wide" data-testid="mobile-nav-projects">Projects</button>
          <button onClick={() => scrollTo("team")} className="block text-sm font-medium text-[#4A5568] uppercase tracking-wide" data-testid="mobile-nav-team">Team</button>
          <Button
            onClick={() => scrollTo("contact")}
            className="w-full bg-[#182649] text-white hover:bg-[#3C75B6] rounded-full px-6 py-3 text-sm font-medium"
            data-testid="mobile-nav-cta"
          >
            Get Details
          </Button>
        </div>
      )}
    </header>
  );
}
